import {
    Code as CodeIcon,
    Storage as StorageIcon,
    Insights as InsightsIcon,
    Cloud as CloudIcon,
    Language as LanguageIcon,
    Security as SecurityIcon,
    Biotech as BiotechIcon,
    Layers as LayersIcon,
} from '@mui/icons-material';

// Single source of truth for every assignable learning path/study plan.
// `id` === the slug stored in user.learning_paths (see backend VALID_LEARNING_PATHS
// in backend/app/schemas.py — keep both lists in sync when adding a new path).
// `learningPathKey` === the LearningTrack.learning_path_key value in the DB
// (see backend/app/repositories.py _LEARNING_PATH_ALIASES for the few paths
// where these differ), or null when the path has no dedicated track yet.
export const LEARNING_PATHS = [
    {
        id: 'python',
        icon: CodeIcon,
        label: 'Python',
        fullLabel: 'Python Programming',
        jobReadyLabel: 'Python Developer Job-Ready',
        summary: 'Variables, loops, functions, files and automation. The most beginner-friendly language there is.',
        description: 'Scripts, automation, testing, APIs',
        emoji: '🐍',
        color: '#3776AB',
        route: '/roadmaps/python-job-ready',
        learningPathKey: 'python',
    },
    {
        id: 'sql',
        icon: StorageIcon,
        label: 'SQL',
        fullLabel: 'SQL & Databases',
        jobReadyLabel: 'SQL / Database Admin Job-Ready',
        summary: 'Read, filter, join and summarise data — the skill that turns a spreadsheet user into a data professional.',
        description: 'Queries, schemas, performance, database admin proof',
        emoji: '🗄️',
        color: '#336791',
        route: '/roadmaps/sql-job-ready',
        learningPathKey: 'sql',
    },
    {
        id: 'data-analysis',
        icon: InsightsIcon,
        label: 'Data Analysis',
        fullLabel: 'Data Analysis',
        jobReadyLabel: 'Data Analyst Job-Ready',
        summary: 'Clean messy data, find patterns, build charts. Go from "I have a spreadsheet" to "I have answers".',
        description: 'Spreadsheets, charts, insights, Power BI',
        emoji: '📊',
        color: '#E87722',
        route: '/roadmaps/data-analyst-job-ready',
        learningPathKey: 'data-analyst',
    },
    {
        id: 'azure',
        icon: CloudIcon,
        label: 'Azure DE',
        fullLabel: 'Azure Data Engineer',
        jobReadyLabel: 'Azure Data Engineer Job-Ready',
        summary: 'Build cloud data pipelines, lakehouse workflows, Fabric/Databricks projects, and portfolio evidence.',
        description: 'Pipelines, lakehouse, Fabric, Databricks',
        emoji: '☁️',
        color: '#0078D4',
        route: '/roadmaps/azure-data-engineer',
        learningPathKey: 'azure-data-engineer',
    },
    {
        id: 'azure-platform',
        icon: SecurityIcon,
        label: 'Azure Platform',
        fullLabel: 'Azure Platform Engineer',
        jobReadyLabel: 'Azure Platform Engineer Job-Ready',
        summary: 'Own Azure landing zones, identity, networking, IaC, governance, monitoring, reliability, and cost controls.',
        description: 'Landing zones, IaC, governance, operations',
        emoji: '🛡️',
        color: '#0F766E',
        route: '/roadmaps/azure-platform-engineer',
        learningPathKey: 'azure-platform-engineer',
    },
    {
        id: 'data-science',
        icon: BiotechIcon,
        label: 'Data Science',
        fullLabel: 'Data Scientist',
        jobReadyLabel: 'Data Scientist Job-Ready',
        summary: 'Frame questions, validate data, build models, evaluate errors, and explain limitations clearly.',
        description: 'Statistics, ML, evaluation, model proof',
        emoji: '🧪',
        color: '#5B21B6',
        route: '/roadmaps/data-scientist-job-ready',
        learningPathKey: 'data-science',
    },
    {
        id: 'full-stack',
        icon: LayersIcon,
        label: 'Full-Stack',
        fullLabel: 'Full-Stack Developer',
        jobReadyLabel: 'Full-Stack Developer Job-Ready',
        summary: 'Frontend, backend, databases, and deployment — build and ship a complete web product end to end.',
        description: 'Frontend + backend, deployed full-stack capstone',
        emoji: '💻',
        color: '#2563EB',
        route: '/roadmaps/full-stack-developer-job-ready',
        learningPathKey: 'full-stack',
    },
    {
        id: 'web-dev',
        icon: LanguageIcon,
        label: 'Web Dev',
        fullLabel: 'Web Development',
        jobReadyLabel: 'Web Development',
        summary: 'HTML, CSS, JavaScript and React. Build things that live in a browser.',
        description: 'HTML, CSS, JavaScript, React',
        emoji: '🌐',
        color: '#61DAFB',
        route: null,
        learningPathKey: null,
    },
];
